/**
 * Only a same-app path may be a post-sign-in destination: "/review/prices?x=1"
 * yes; "https://evil.example", "//evil.example" or "/\\evil" never (an open
 * redirect on the sign-in page is a phishing kit).
 */
export function safeReturnTo(value: unknown, fallback = '/'): string {
  if (typeof value !== 'string' || !value.startsWith('/')) return fallback;
  if (value.startsWith('//') || value.startsWith('/\\')) return fallback;
  if (value.startsWith('/auth/')) return fallback;
  return value;
}
